module.exports = __webpack_public_path__ + "media/images/icon-exclamation-mark-bf8bdf442d0798979fa1e5f65ff9785f.png";